import cx from 'classnames';

export interface CircularLoaderProps {
  className?: string;
}

export default function CircularLoader({ className }: CircularLoaderProps) {
  return (
    <div className={cx('circular-loader', className)}>
      <span className="circular-loader__text">Loading...</span>
    </div>
  );
}
